// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgx_a bhv_vf bhv_a bhv_q bhv_k","AdSlotMail__mail--notLoaded":"bgx_b bhv_eu bhv_bj bhv_vu","show-ad-not-loaded":"bgx_c","AdSlotMail__cta":"bgx_e"};